var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsRequestcancellation2023371(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 13.36C28.19 13.24 28.14 13.12 28.05 13.04C28 12.99 27.94 12.95 27.87 12.93L4.49004 3.82999C4.43004 3.80999 4.37004 3.79999 4.31004 3.79999C4.18004 3.79999 4.05004 3.84999 3.95004 3.94999C3.80004 4.08999 3.76004 4.29999 3.83004 4.48999L12.93 27.88C13 28.06 13.17 28.19 13.37 28.2C13.57 28.22 13.75 28.11 13.85 27.95L18.98 18.97L19 18.96L27.95 13.85C28.12 13.75 28.22 13.56 28.2 13.36ZM26.32 13.6L18.68 17.96L18.62 17.9L13.76 13.04C13.57 12.85 13.23 12.85 13.04 13.04C12.84 13.24 12.84 13.56 13.04 13.76L17.96 18.68L17.92 18.75L13.49 26.51L13.41 26.3L5.20004 5.19999L26.52 13.49L26.32 13.6Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsRequestcancellation2023371);
export default __webpack_public_path__ + "static/media/beemg-icons-requestcancellation-2023-37 1.585b4c7c234cd0873209e689cfd20405.svg";
export { ForwardRef as ReactComponent };